import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import find from 'lodash/find'

import * as updateFile from '../../../actions/resolutiondetails';
import * as fileupload from '../../../actions/fileupload';
import * as regData from '../../../../appConstants'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class UpdateFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            setValue: false,
            isFileUploadSet: false,
            isFileDetailsUpdateSet: false,
            newfile: null,
        };
    }
    handleChange(field, e) {
        const data = Object.assign({}, this.state.data, { [field]: e.target.value });
        this.setState(Object.assign({}, this.state, { 'data': data }));
    }
    handleRequestClose = () => {
        this.props.closeDialog();
    };

    cancel = () => {
        this.props.closeDialog();
    };

    setData = () => {
        // console.log('setData=>', this.state.data)
        const data = Object.assign({}, this.state.data, { 'fileName': this.state.newfile.name });
        this.setState(Object.assign({}, this.state, { 'data': data }));
        this.setState({ isFileDetailsUpdateSet: true })
        let formData = new FormData();
        formData.append('file', this.state.newfile)
        formData.append('request', JSON.stringify(this.state.data))
        this.props.actions.updateFileDetails(this.props.id, formData);
    };

    handleFileSelected(file) {
        this.state.newfile = file.target.files[0]
        this.setState({ isFileDetailsUpdateSet: false })
    }
    render() {
        const { data, resolutionDetails } = this.props;
        // console.log('this.state=>', this.state)
        let result = null;
        if (resolutionDetails && resolutionDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (!this.state.setValue) {
            this.state.data = data;
            this.state.setValue = true;
        }
        if (resolutionDetails && resolutionDetails.apiPostResult && this.state.isFileDetailsUpdateSet) {
            // console.log('updatefile Popup=>', this.state.data)
            this.props.closeDialog();
            this.setState({ isFileDetailsUpdateSet: false });
            this.props.getUpdateFileDetails(this.state.data);
            this.setState({ newfile: null })
            if (this.refs.fileUpdate)
                this.refs.fileUpdate.value = null;
            // console.log('updatefile Popup=>', this.state.data)
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose} className="modaldialog">
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Update File</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row">
                            <div className="col-md-12">
                            Please enter the File Description and attach the updated document
                            </div>
                            <hr />
                            <div className="col-md-12">
                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                    name="notes1" label="File Description" multiline={true}
                                    validators={[regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                    errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                    value={this.state.data.description} onChange={this.handleChange.bind(this, 'description')}
                                />
                            </div>
                            <div className="col-12">
                                <input type="file" accept="application/pdf" id="fileUpdate" ref="fileUpdate" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                <label htmlFor="fileUpdate">
                                    <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Choose file</Button>
                                </label>
                                <label className="m-2">{ this.state.newfile ? this.state.newfile.name : ""}</label>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.cancel} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={this.setData.bind(this)} variant="raised"
                            className={!this.state.newfile ? "jr-btn disabled text-white" : "jr-btn bg-primary text-white"}
                            disabled={!this.state.newfile}>Update</Button>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, updateFile, fileupload), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(UpdateFile);


// WEBPACK FOOTER //
// ./app/resolutiondetails/addresolution/updatefile.js